var map = {
	".": 18557,
	"./": 18557,
	"./DailyMotion": 41254,
	"./DailyMotion.js": 41254,
	"./Facebook": 30770,
	"./Facebook.js": 30770,
	"./FilePlayer": 29990,
	"./FilePlayer.js": 29990,
	"./Kaltura": 84063,
	"./Kaltura.js": 84063,
	"./Mixcloud": 19763,
	"./Mixcloud.js": 19763,
	"./Mux": 1033,
	"./Mux.js": 1033,
	"./SoundCloud": 67548,
	"./SoundCloud.js": 67548,
	"./Streamable": 26504,
	"./Streamable.js": 26504,
	"./Twitch": 81906,
	"./Twitch.js": 81906,
	"./Vidyard": 96862,
	"./Vidyard.js": 96862,
	"./Vimeo": 53690,
	"./Vimeo.js": 53690,
	"./Wistia": 1276,
	"./Wistia.js": 1276,
	"./YouTube": 76260,
	"./YouTube.js": 76260,
	"./index": 18557,
	"./index.js": 18557,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players": 18557,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/": 18557,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/DailyMotion": 41254,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/DailyMotion.js": 41254,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Facebook": 30770,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Facebook.js": 30770,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/FilePlayer": 29990,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/FilePlayer.js": 29990,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Kaltura": 84063,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Kaltura.js": 84063,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Mixcloud": 19763,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Mixcloud.js": 19763,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Mux": 1033,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Mux.js": 1033,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/SoundCloud": 67548,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/SoundCloud.js": 67548,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Streamable": 26504,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Streamable.js": 26504,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Twitch": 81906,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Twitch.js": 81906,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Vidyard": 96862,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Vidyard.js": 96862,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Vimeo": 53690,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Vimeo.js": 53690,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Wistia": 1276,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/Wistia.js": 1276,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/YouTube": 76260,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/YouTube.js": 76260,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/index": 18557,
	".pnpm/react-player@2.16.1_react@17.0.2/node_modules/react-player/lazy/players/index.js": 18557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52595;